// extracted by mini-css-extract-plugin
export var container = "_i2-1";
export var cornerButtonContainer = "_i2-6";
export var disabled = "_i2-2";
export var dragActive = "_i2-3";
export var fileContainer = "_i2-5";
export var hiddenInput = "_i2-4";
export var widthContainer = "_i2-0";